<template>
    <div class="dropdown uk-inline">
        <button class="uk-button" type="button">
            <span class="uk-text-meta">{{ title }} </span>
            <span>({{ selectedOptionsCount }}/{{ optionsCount }})</span>
            <img class="rotate-90" :src="require('@/assets/images/icons/icon-arrow-next.svg')" alt="" />
        </button>
        <div :id="title" ref="dropdown" uk-dropdown="mode: click">
            <ul class="uk-nav uk-dropdown-nav uk-padding-small uk-open">
                <li
                    v-for="item in checkboxData"
                    :key="item.id.value + item.name"
                    class="uk-active"
                    @change="emitData(item.toggleAll)"
                >
                    <input
                        :id="item.id.value + item.name"
                        class="uk-checkbox uk-margin-small-right"
                        type="checkbox"
                        :value="item.id"
                        :checked="item.active"
                        @click="toggleAll(item)"
                    />
                    <label :class="{ dropdownLabel: item.defaultLabel }" :for="item.id.value + item.name">{{
                        item.name
                    }}</label>
                </li>
            </ul>
        </div>
    </div>
</template>

<script lang="js">
import Vue from "vue";
import * as lodash from "lodash";

export default Vue.extend({
    name: "CheckboxDropdown",
    props: {
        title: {
            type: String,
            required: true,
        },
        data: {
            type: Array,
            default: () => [],
            required: true,
        },
    },
    data() {
        return {
            checkboxData: [],
            selectAllActive: false,
        };
    },
    computed: {
        selectedOptionsCount() {
            let selected = 0;

            this.checkboxData.forEach((item) => {
                if (item.active && !item.toggleAll) {
                    selected++;
                }
            });

            return selected;
        },
        optionsCount() {
            return lodash.find(this.data, "toggleAll") ? this.data.length - 1 : this.data.length;
        },
    },
    beforeMount() {
        if (this.data.length) {
            this.checkboxData = this.data;
        }
    },
    methods: {
        emitData(toggleAll) {
            const ids = toggleAll ? [] : this.checkboxData.filter((i) => i.active);
            this.$store.commit("graphs/mutateFilterDropdowns", {
                filterType: this.title,
                data: ids,
            });
        },
        toggleAll(item) {
            item.active = !item.active;

            // If select all is checked and an option is unchecked, uncheck toggle all
            this.uncheckSelectAll();

            // If checkbox is select all, toggle all dropdown options
            if (item.toggleAll) {
                for (const label in this.data) {
                    this.data[label].active = item.active;
                }

                this.selectAllActive = item.active;
            }
        },
        uncheckSelectAll() {
            if (this.selectAllActive) {
                const selectAll = lodash.find(this.data, "toggleAll");
                selectAll.active = false;
                this.selectAllActive = false;
            }
        },
    },
});
</script>
